export const waitForImages = async (root: HTMLElement) => {
  const images = Array.from(root.querySelectorAll("img"));
  if (images.length === 0) return;

  await Promise.all(
    images.map(async (img) => {
      // Already loaded
      if (img.complete && img.naturalWidth > 0) return;

      // Prefer decode() when available
      if (typeof (img as HTMLImageElement).decode === "function") {
        try {
          await (img as HTMLImageElement).decode();
          return;
        } catch {
          // Fall back to load/error events
        }
      }

      await new Promise<void>((resolve) => {
        const done = () => {
          img.removeEventListener("load", done);
          img.removeEventListener("error", done);
          resolve();
        };
        img.addEventListener("load", done);
        img.addEventListener("error", done);
      });
    })
  );
};

export const dataUrlToPngBlobChunked = (dataUrl: string): Blob => {
  const [, b64] = dataUrl.split(",");
  const byteString = atob(b64);

  // Chunked conversion to avoid stack/memory issues on mobile
  const chunkSize = 8192;
  const chunks: Uint8Array[] = [];

  for (let i = 0; i < byteString.length; i += chunkSize) {
    const chunk = byteString.slice(i, i + chunkSize);
    const bytes = new Uint8Array(chunk.length);
    for (let j = 0; j < chunk.length; j++) {
      bytes[j] = chunk.charCodeAt(j);
    }
    chunks.push(bytes);
  }

  const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }

  return new Blob([result], { type: "image/png" });
};
